// Reuse the same category buttons, so URL state and listeners survive resizing.
export function installViewChrome() {
  const mobile = matchMedia("(max-width: 760px)");
  const filters = document.querySelector("#filterDialog");
  const button = document.querySelector("#filterButton");
  const domains = document.querySelector(".domain-filters");
  document.querySelector("#headerShare").append(document.querySelector("#shareViewButton"));
  function place() {
    if (filters.open) filters.close();
    const brand = document.querySelector("#aboutButton");
    brand.setAttribute("aria-label", mobile.matches ? "À propos d’Entourages" : "Retour à nocodefunctions.com");
    if (mobile.matches) { brand.setAttribute("aria-haspopup", "dialog"); brand.setAttribute("aria-controls", "aboutDialog"); }
    else { brand.removeAttribute("aria-haspopup"); brand.removeAttribute("aria-controls"); }
    document.querySelector(mobile.matches ? "#mobileDomains" : "#desktopDomains").append(domains);
  }
  button.addEventListener("click", () => {
    document.querySelector("#closeInspector").click();
    filters.showModal(); button.setAttribute("aria-expanded", "true");
  });
  document.querySelector("#closeFilters").addEventListener("click", () => filters.close());
  filters.addEventListener("close", () => button.setAttribute("aria-expanded", "false"));
  document.querySelector("#mobileRecenter").addEventListener("click", () => {
    filters.close(); document.querySelector("#recenterButton").click();
  });
  document.querySelector("#aboutButton").addEventListener("click", event => {
    if (!mobile.matches) return;
    event.preventDefault(); document.querySelector("#aboutDialog").showModal();
  });
  document.querySelector("#closeAbout").addEventListener("click", () => document.querySelector("#aboutDialog").close());
  // Backdrop dismissal complements the close button and native Escape/focus handling.
  document.querySelectorAll("dialog").forEach(dialog => dialog.addEventListener("click", event => {
    if (!mobile.matches || event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  }));
  document.addEventListener("keydown", event => {
    if (mobile.matches && event.key === "Escape" && !document.querySelector("dialog[open]")) document.querySelector("#closeInspector").click();
  });
  mobile.addEventListener("change", place);
  place();
}
